import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Document, Page, pdfjs } from "react-pdf";
import "../assets/css/DetailPage.css";
import img1 from "../assets/images/3.webp";

// ✅ PDF worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function CollateralDetail() {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const fullUrl = window.location.href;
  const department = ['admin', 'marketing', 'presales', 'research', 'sales'];
  const { slug } = useParams();
  const navigate = useNavigate();
  const userId = sessionStorage.getItem("user_id");
  const userDepartment = sessionStorage.getItem("user_department");
  const [collaterals, setCollaterals] = useState([]);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(null);

  // ✅ Fetch data on mount
  useEffect(() => {
    
    const urlParts = fullUrl.split("/");
    const keyword = urlParts[urlParts.length - 1] || "";
    const tag = urlParts[urlParts.length - 2] || "";

    axios
      .post(`${BASE_URL}/collaterals/details-api/`, {
        keyword: keyword,
        tag: tag,
        userId: userId,
      })
      .then((res) => {
        const data = res.data;
        if (Array.isArray(data) && data.length > 0) {
          const item = data[0]; // take first match

          if (item.title && item.title !== "nan") {
            setCollaterals(item);
          } else {
            setCollaterals(null);
          }
        } else {
          setCollaterals(null);
        }

      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  // ✅ Match record using slug
  const poc = collaterals

  const handleRequest = async () => {
    await axios.post(`${BASE_URL}/access-control/api/request-download/`, {
      drive_id: poc.drive_id,
      item_id: poc.item_id,
      module: "marketing",
      userId: userId,
      category: poc.tag,
      docID: poc.id,
    });

    // refresh status
    setCollaterals({
      ...collaterals,
      download_status: "pending",
    });
  };

  const handleBookmark = async () => {
    try {
      await axios.post(`${BASE_URL}/access-control/api/add-bookmark/`, {
        drive_id: poc.drive_id,
        item_id: poc.item_id,
        module: "marketing",
        userId: userId,
        category: poc.category,
        docID: poc.id,
        title: poc.title,
        siteUrl: fullUrl,
      });

      // Toggle UI state
      setIsBookmarked((prev) => !prev);

    } catch (err) {
      console.error("Bookmark error:", err);
    }
  };

  const handleDownload = () => {
    window.open(
      `${BASE_URL}/access-control/api/download?drive_id=${poc.drive_id}&item_id=${poc.item_id}`
    );
  };

  const handleDeleteBookmark = async () => {
    try {
      await axios.post(
        `${BASE_URL}/access-control/api/delete-bookmarked/`,
        {
          drive_id: poc.drive_id,
          item_id: poc.item_id,
          module: "marketing",
          userId: userId,
          category: poc.category,
          docID: poc.id,
        }
      );

      // ✅ Remove from UI instantly
      setIsBookmarked((prev) => !prev);

    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  if (!poc) {
    return (
      <div className="container py-5 text-center">
        <h3>Collateral not found</h3>
        <button className="btn btn-secondary mt-3" onClick={() => navigate("/")}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="poc-detail container-fluid py-5">
      <div className="container">
        <div className="row">
          {/* LEFT COLUMN */}
          <div className="col-md-5 col-sm-12 left-panel">
            {poc.download_status === "approved" || department.includes(userDepartment) ? (
              <button onClick={handleDownload} className="btn downloadbtn mt-3">Download {poc.tag}</button>
            ) : poc.download_status === "pending" ? (
              <button disabled className="btn downloadbtn mt-3">Pending Approval - {poc.tag}</button>
            ) : (
              <button onClick={handleRequest} className="btn downloadbtn mt-3">Request Download - {poc.tag}</button>
            )}
            <h2>{poc.title}</h2>
            <p>
              <span className="tooltip-container">
                {poc.category}
                <span className="tooltip-text">Segment</span>
              </span>
              <span className="tooltip-container">
                | {poc.area}
                <span className="tooltip-text">Area</span>
              </span>
            </p>
            <p class="sub-heading">Other Details</p>
            <table className="table-cls">
              <tbody>
                <tr>
                  <th width="30%">Company</th>
                  <td width="70%">{poc.company == "nan" ? "NA" : poc.company}</td>
                </tr>
                <tr>
                  <th>Owner</th>
                  <td>{poc.owner == "nan" ? "NA" : poc.owner}</td>
                </tr>
                <tr>
                  <th>Website URL</th>
                  <td><a href={poc.collateral_link} target="_blank" rel="noopener noreferrer">
                    {poc.collateral_link}
                  </a></td>
                </tr>
                <tr>
                  <th>WordPress Link</th>
                  <td>{poc.pdf_link ? (<a href={poc.pdf_link} target="_blank" rel="noopener noreferrer">
                    {poc.pdf_link}
                  </a>) : 'NA'}</td>
                </tr>
              </tbody>
            </table>
            <p class="sub-heading">Meta Details</p>
            <ul>
              <li>
                <strong>Meta Title: </strong>
                {poc.meta_title?.trim() ? poc.meta_title : "Not Available"}
              </li>
              <li>
                <strong>Meta Description: </strong>
                {poc.meta_description?.trim() ? poc.meta_description : "Not Available"}
              </li>
              <li>
                <strong>Meta Keywords: </strong>
                {poc.meta_keywords?.trim() ? poc.meta_keywords : "Not Available"}
              </li>
            </ul>
          </div>

          {/* RIGHT COLUMN (PDF VIEWER) */}
          <div className="col-md-7 col-sm-12 right-panel">
            <div className="pdf-wrapper">
              {poc.sharepoint_embed_link ? (
                <iframe
                  src={poc.sharepoint_embed_link}
                  width="600"
                  height="500"
                  allowFullScreen
                  style={{ overflow: "hidden" }}
                  title={poc.title}
                />
              ) : (
                <div className="text-center text-muted py-5">
                  <p>No PDF available for this Collateral.</p>
                </div>
              )}
            </div>
            <p class="doc_name">{poc.pdf_name}</p>
            {/* bookmark btn  */}
            {!isBookmarked ?
              <button onClick={handleBookmark} className="btn bookmarkbtn mt-3"><i className="fa fa-bookmark"></i></button>
              :
              <button onClick={(e) => {
                e.stopPropagation();
                handleDeleteBookmark();
              }} className="btn bookmarkbtn mt-3"><i className="fa fa-times"></i></button>

            }
          </div>
          <div className="col-md-12 col-sm-12 left-panel">
            <p class="sub-heading">Banner Sentence</p>
            <p>{poc.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
